import {IInterestFormPage} from '@src/Api/Umbraco/Hooks/useSignupForm';
import settingsSlice from '@src/Store/Slices/Settings.slice';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {
  IValidationElementFragmentFragment,
  useSettingsLazyQuery,
} from '~Api/Graphql/gql/types.generated';

const useInitSetting = () => {
  const [fetchSetting, {loading}] = useSettingsLazyQuery();
  const dispatch = useDispatch();

  const init = useCallback(async () => {
    const {data} = await fetchSetting({fetchPolicy: 'no-cache'});
    const settingsNode = data?.allSettings?.items[0];
    if (settingsNode?.__typename !== 'Settings') return;

    const rules: IValidationElementFragmentFragment[] = [];

    const {
      cover,
      webCover,
      title,
      subtitle,
      cTALabel,
      defaultHeaderImage,
      sessionAlertMessage,
      signupForm,
      signupSteps,
      passwordValidation
    } = settingsNode;

    const additionnalStep: IInterestFormPage[] = [];

    if (signupSteps?.length) {
      signupSteps.forEach(step => {
        if (step && step.__typename === 'FormPage') {
          additionnalStep.push(step);
        }
      });
    }

    if (passwordValidation) {
      passwordValidation.forEach(item => {
        if (item?.content?.__typename === 'ValidationElement') {
          rules.push(item.content);
        }
      });
    }

    const setupInitialState = () => {
      dispatch(
        settingsSlice.actions.setSessions({
          alertMessage: sessionAlertMessage,
        }),
      );
      dispatch(
        settingsSlice.actions.setOnboarding({
          cTALabel: cTALabel,
          title,
          subtitle,
          cover: cover?.url,
          webCover: webCover?.url,
        }),
      );
      dispatch(
        settingsSlice.actions.setProfile({
          cover: defaultHeaderImage?.url,
        }),
      );
      dispatch(settingsSlice.actions.setSignup({signupForm, additionnalStep}));
      dispatch(settingsSlice.actions.setPassword({rules}));
    };

    setupInitialState();
  }, [dispatch, fetchSetting]);
  return {init, loading};
};

export default useInitSetting;
